module.exports = __webpack_public_path__ + "static/media/LTC-BRL.c763d697.svg";